import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root: 'relative inline-flex',
        preview:
            'relative flex items-center justify-center overflow-hidden border-[0.0625rem] border-(--border-glass) ' +
            'bg-[rgba(236,241,247,0.45)]',
        image: 'h-full w-full object-cover',
        loaderIcon: 'animate-spin text-slate-400',
        emptyIconWrap: 'text-slate-400',
        overlay:
            'pointer-events-none absolute inset-0 ' +
            'shadow-[inset_0.125rem_0.125rem_0.3125rem_0_rgba(163,177,198,0.2),inset_-0.125rem_-0.125rem_0.3125rem_0_rgba(255,255,255,0.7)]',
        clearButton: 'absolute right-0 top-0 translate-x-1/4 -translate-y-1/4 text-(--text-dark)'
    },
    variants: {
        loading: {
            true: {
                preview: 'cursor-not-allowed opacity-70'
            },
            false: {
                preview: 'cursor-pointer'
            }
        },
        rounded: {
            true: {
                preview: 'rounded-full',
                overlay: 'rounded-full'
            },
            false: {
                preview: 'rounded-2xl',
                overlay: 'rounded-2xl'
            }
        }
    }
} satisfies ComponentTheme;
